<div class="instant-pay-timer-wrapper">
  
  <!-- Available State -->
   <div class="banner-content compact-countdown" *ngIf="instantPayAvailability?.isAvailable">
    <div class="compact-header">
      <ion-icon name="wallet-outline" class="header-icon"></ion-icon>
      <span class="header-text">Instant Pay:</span>
    </div>
    <div class="compact-time-blocks">
      <div class="compact-time-block">
        <div class="time-value">Available Now!</div>
      </div>
    </div>
  </div>

  <!-- Countdown State -->
  <div class="banner-content compact-countdown instant-pay-timer-wrapper" *ngIf="!instantPayAvailability?.isAvailable && timeDetails">
    <div class="compact-header">
      <ion-icon name="wallet-outline" class="header-icon"></ion-icon>
      <span class="header-text">Instant Pay:</span>
    </div>
    
    <div class="compact-time-blocks">
      <div class="compact-time-block">
        <div class="time-value">{{ timeDetails.days }}</div>
        <div class="time-label">Days</div>
      </div>
      <div class="compact-time-block">
        <div class="time-value">{{ timeDetails.hours }}</div>
        <div class="time-label">Hours</div>
      </div>
      <div class="compact-time-block">
        <div class="time-value">{{ timeDetails.minutes }}</div>
        <div class="time-label">Mins</div>
      </div>
    </div>
  </div>

</div>